module.exports = __webpack_public_path__ + "static/img/zh_CN3.ac35149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zh_CN3.png
// module id = Bnek
// module chunks = 1